export const schoolConstants = {
    SCHOOL_ADDED_REQUEST:'SCHOOL_ADDED_REQUEST',
    SCHOOL_ADDED_SUCCESS:'SCHOOL_ADDED_SUCCESS',
    SCHOOL_ADDED_FAILURE:'SCHOOL_ADDED_FAILURE',

    SCHOOL_BY_ID_REQUEST:'SCHOOL_BY_ID_REQUEST',
    SCHOOL_BY_ID_SUCCESS:'SCHOOL_BY_ID_SUCCESS',
    SCHOOL_BY_ID_FAILURE:'SCHOOL_BY_ID_FAILURE',

    SCHOOL_LIST_REQUEST:'SCHOOL_LIST_REQUEST',
    SCHOOL_LIST_SUCCESS:'SCHOOL_LIST_SUCCESS',
    SCHOOL_LIST_ERROR:'SCHOOL_LIST_ERROR',

    UPDATE_SCHOOL_REQUEST:'UPDATE_SCHOOL_REQUEST',
    UPDATE_SCHOOL_SUCCESS:'UPDATE_SCHOOL_SUCCESS',
    UPDATE_SCHOOL_FAILURE:'UPDATE_SCHOOL_FAILURE',

    DELETE_SCHOOL_REQUEST:'DELETE_SCHOOL_REQUEST',
    DELETE_SCHOOL_SUCCESS:'DELETE_SCHOOL_SUCCESS',
    DELETE_SCHOOL_FAILURE:'DELETE_SCHOOL_FAILURE'
    
};